import '@scalar/api-reference/style.css'
import {createApiReference} from '@scalar/api-reference'

const PERSISTENT_CONTAINER_ID = 'docs-persistent-container';
const PLACEHOLDER_ID = 'docs-placeholder';
let scalarInstance = null;
let themeObserver = null;

export default (apiUrl, apiKey) => ({
    apiUrl: apiUrl,
    apiKey: apiKey,
    _ajaxHandler: null,

    init() {
        const container = document.getElementById(PERSISTENT_CONTAINER_ID);
        if (!container) return;

        // Position container as fixed overlay below the navbar
        const header = document.getElementById('header');
        const headerHeight = header ? header.getBoundingClientRect().height : 0;
        container.style.position = 'fixed';
        container.style.top = `${headerHeight}px`;
        container.style.left = '0';
        container.style.right = '0';
        container.style.bottom = '0';
        container.style.overflowY = 'auto';
        container.style.zIndex = '9';
        container.classList.remove('hidden');
        container.style.display = '';

        // Initialize Scalar only once
        if (!scalarInstance) {
            const docsEl = document.createElement('div');
            docsEl.id = 'docs';
            container.appendChild(docsEl);

            scalarInstance = createApiReference(docsEl, this.getConfiguration());
            this.setupThemeObserver();
        }

        this.syncTheme();
        this.hideToggleThemeIcon();

        // Listen for navigation to hide docs
        this._ajaxHandler = () => {
            this.hideContainer();
        };
        document.addEventListener('ajax:before', this._ajaxHandler);
    },

    destroy() {
        if (this._ajaxHandler) {
            document.removeEventListener('ajax:before', this._ajaxHandler);
        }
        this.hideContainer();
    },

    hideContainer() {
        const container = document.getElementById(PERSISTENT_CONTAINER_ID);
        if (container) {
            container.classList.add('hidden');
            container.style.display = 'none';
            container.style.position = '';
            container.style.top = '';
            container.style.left = '';
            container.style.right = '';
            container.style.bottom = '';
            container.style.overflowY = '';
            container.style.zIndex = '';
        }
    },

    setupThemeObserver() {
        if (themeObserver) return;

        themeObserver = new MutationObserver(() => {
            this.syncTheme();
            this.hideToggleThemeIcon();
        });

        themeObserver.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['data-theme']
        });
    },

    syncTheme() {
        if (this.isDarkMode()) {
            document.querySelector('.toggle-icon-light')?.click();
        } else {
            document.querySelector('.toggle-icon-dark')?.click();
        }
    },

    getConfiguration() {
        return {
            url: `https://${this.apiUrl}/api/openapi.json`,
            withDefaultFonts: false,
            darkMode: this.isDarkMode(),
            authentication: {
                preferredSecurityScheme: 'ApiKeyAuth',
                securitySchemes: {
                    ApiKeyAuth: {
                        value: this.apiKey,
                    },
                },
            },
            defaultOpenAllTags: true,
            defaultHttpClient: {
                targetKey: 'js',
                clientKey: 'fetch',
            },
            expandAllModelSections: true,
            expandAllResponses: false,
            hideSearch: true,
            hideClientButton: true,
            hideModels: true,
            layout: 'modern',
            showDeveloperTools: 'never',
            telemetry: false,
            orderRequiredPropertiesFirst: true,
        };
    },

    isDarkMode() {
        return document?.documentElement?.dataset?.theme !== 'corporate';
    },

    hideToggleThemeIcon() {
        const selector = this.isDarkMode() ? '.toggle-icon-dark' : '.toggle-icon-light';
        const el = document.querySelector(selector);
        if (el?.parentNode?.parentNode) {
            el.parentNode.parentNode.style.display = 'none';
        }
    },
});
